<!--更新成本-->
<template>
    <el-dialog :title="msg('更新成本')" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        :lose-on-press-escape="false"
        width="500px"
    >
        <el-form :model="cost" label-width="100px" @submit.native.prevent>
            <el-form-item label="成本"  prop="value" >
                <el-input-number v-model="cost.value" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="" prop="value"  >
                <el-checkbox v-model="cost.type">
                    <span>
                        记录更新该商品单件参考成本
                    </span>
                </el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="doSumit()"  native-type="submit">提交</el-button>
                <el-button @click="visible = false">取消</el-button>
            </el-form-item>
        </el-form>

        <!-- <div style="text-align:center;">
            <el-button type="primary" native-type="submit" @click="doSumit()">提交</el-button>
            <el-button @click="visible = false">取消</el-button>
        </div> -->
    </el-dialog>
</template>

<script>
export default {
    name: "SkuUpdateDialog",
    data(){
        return {
            visible: false,
            type: 0, //0-单条，1-批量,  detailId是单条值，stockId是单条值， 当1时，detailId是多条值：1,2,3, stockId是多条值：1,2,3
            cost:{
                value: 0,
                type: false
            },
            detailIds: null,
        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
    },
    methods: {
        showDialog(detailIds){
            this.detailIds = detailIds;
            this.cost = {
                value: 0,
                type: false
            }
            this.visible = true;
        },
        autoSave(e){
            if(e.keyCode == 13){
                this.doSumit();
            }
        },
        doSumit(){
            if(!this.cost.value && this.cost.value != 0){
                return;
            }
            this.$axios.post(this.$kit.api.stockDetail.updateDetailCosts
                +"?detailIds="+this.detailIds 
                +"&cost="+(((this.cost.value*100).toFixed(0) || 0))
                +"&type="+(this.cost.type?1:0)
            ).then((result) => {
                if(result.status){
                        this.$message( {
                            dangerouslyUseHTMLString: true,
                            message:Object.keys(result.data).map(key => key+":"+result.data[key]).join("<br/>")
                    });
                    
                    this.$emit("finish");
                    this.visible=false;
                }else{
                    this.$message(result.msg);
                }
            });
        }
    }

}
</script>